import { css } from 'linaria';

export const adplatformTrainingReelsSectionTextContent = css`
  width: 595px;
  margin-bottom: 40px;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const adplatformTrainingReelsSectionTitle = css`
  && {
    margin-bottom: 16px;

    @media (--to-desktop) {
      margin-bottom: 12px;
      font-size: 28px;
      line-height: 34px;
    }
  }
`;

export const adplatformTrainingReelsSectionText = css`
  && {
    line-height: 28px;

    @media (--to-desktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const adplatformTrainingReelsSectionTabs = css`
  && {
    margin-bottom: 40px;
    margin-left: 0;

    @media (--only-mobile) {
      margin-bottom: 32px;
    }
  }
`;

export const adplatformTrainingReelsSectionInstruction = css`
  @media (--only-mobile) {
    p {
      display: none;
    }
  }
`;

export const adplatformTrainingReelsSectionInstructionLast = css`
  @media (--only-mobile) {
    order: 2;
  }
`;

export const adplatformTrainingReelsSectionGrid = css`
  display: grid;
  grid-template-columns: repeat(3, 372px);
  grid-template-rows: auto;
  padding: 0;
  margin: 0;
  column-gap: 32px;
  list-style: none;
  row-gap: 32px;

  @media (--only-desktop) {
    grid-template-columns: repeat(3, 292px);
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 314px);
  }

  @media (--only-mobile) {
    grid-template-columns: 100%;
    column-gap: 0;
  }
`;
